module.exports = __webpack_public_path__ + "img/icon_bms6.ec476a93.jpg";